import { render, staticRenderFns } from "./ArrowPrevIcon.vue?vue&type=template&id=d95b1eda&scoped=true"
import script from "./ArrowPrevIcon.vue?vue&type=script&lang=js"
export * from "./ArrowPrevIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95b1eda",
  null
  
)

export default component.exports